import { canManage } from '../auth/session.js';

/**
 * ehr#847: Settings follows the rule the API already enforces. Practice settings (Data &
 * settings), Manage Users and the Access Rights Matrix are saved only by admins and managers
 * (requireRole('admin', 'manager') on /practice, /settings, /payors, /sliding-scale, /audit,
 * /auto-logout, /payments, /import); everyone else was shown them with Save on, and every save was
 * refused. For anyone else now:
 *  - Manage Users, Access Rights Matrix, Auto Logout and Audit log aren't offered;
 *  - Data & settings leaves out the panes whose data the API won't even show them (Payments,
 *    Backup & data, Auto logout, Audit log);
 *  - the other practice panes open read-only, with no Save changes;
 *  - their own panes stay theirs: Email & calendar (their mailbox and calendar) and the Opt-Out
 *    Center (checked per client by the API, for the clients they can open).
 */
export const canManageSettings = (role: string | null | undefined): boolean =>
  canManage(role ?? undefined);

/** Data & settings panes only admins and managers see (the API refuses their data to others). */
export const MANAGER_ONLY_PANES: readonly string[] = ['payments', 'data', 'autologout', 'audit'];

/** Data & settings panes anyone edits for themselves (the API checks each change). */
export const PERSONAL_PANES: readonly string[] = ['mail', 'optouts'];

export const paneShown = (key: string, role: string | null | undefined): boolean =>
  canManageSettings(role) || !MANAGER_ONLY_PANES.includes(key);

export const paneReadOnly = (key: string, role: string | null | undefined): boolean =>
  !canManageSettings(role) && !PERSONAL_PANES.includes(key);

/** The footer line on a read-only pane, in place of Save changes. */
export const SETTINGS_READ_ONLY_NOTE =
  'You can view these settings. Only admins or managers can change them.';
